import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { FiscalYearProvider } from './context/FiscalYearContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './features/mobileAdmin/query';
import './index.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter>
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <FiscalYearProvider>
                    <App />
                </FiscalYearProvider>
            </AuthProvider>
        </QueryClientProvider>
    </BrowserRouter>
);
